import { gql } from "@apollo/client";

export const CreateInstalledBaseNodeAttribute = gql`
    mutation CreateInstalledBaseNodeAttribute ($input: PropertyDefinitionCreateAttributesInput!){
        createInstalledBaseNodePropertyDefinition(input: $input) {
            id
            preferredName
        }
    }
`;
